import { ToastAction } from '@/components/ui/toast'
import {
  useUndoCleaningAction,
  type UndoActionProps,
} from '@/components/cleaning/use-undo-cleaning-action'

/**
 * The Undo button inside an action's confirmation toast (CAP-511).
 *
 * The board's one-tap actions sit a misclick apart in a dense table, and until
 * this there was nothing to take one back with. A misclicked ack is the case
 * that matters: it retires the row AND clears the heads-up that was asking for
 * the crew to be chased.
 */
export function UndoAction(props: UndoActionProps) {
  const { undo, busy } = useUndoCleaningAction(props)

  return (
    <ToastAction
      altText={`Undo: ${props.describe}`}
      disabled={busy}
      // Radix closes the toast on its own once the action is clicked, so the
      // result arrives as the next toast rather than in place of this one.
      onClick={undo}
    >
      Undo
    </ToastAction>
  )
}
